import React from 'react';
import { Translate } from 'react-redux-i18n';
import FranchiseInput from '../../franchises/input/FranchiseInput';

/**
 * Create Franchise content - designed to be embedded in SystemSettings container.
 */
const CreateFranchiseContent = () => {
  return (
    <>
      <h2>
        <Translate value={'franchises.page.create.title'} />
      </h2>
      <FranchiseInput mode='create' />
    </>
  );
};

export default CreateFranchiseContent;
